module.exports = __webpack_public_path__ + "static/media/hackers.6e141197.gif";